export enum UserRole {
  SUPPLIER = 'supplier',
  BUYER = 'buyer',
  ADMIN = 'admin',
}
